import { FC, useEffect, useState } from "react";
import ModalHeading from "../ModalHeading";
import { Button, Upload, message } from "antd";
import {
  cloudSVG,
  noneUploadDocument,
  trashSVG,
} from "../../../../../assets/SVGs/SVGs";
import { useIntl } from "react-intl";

interface DocumentsStepProps {
  formData: FormData;
}
const DocumentsStep: FC<DocumentsStepProps> = ({ formData }) => {
  const [documentsState, setDocumentsState] = useState({
    work_permit: formData.get("work_permit") ? "work_permit" : "",
    insurance_document: formData.get("insurance_document")
      ? "insurance_document"
      : "",
    compliance_regulation: formData.get("compliance_regulation")
      ? "compliance_regulation"
      : "",
  });
  const handleUpload = async ({ file, onSuccess }: any, name: string) => {
    if (!file) {
      return;
    }
    if (file.type !== "application/pdf") {
      message.error("يجب عليك رفع ملف من نوع pdf");
      return;
    }
    console.log(file.size);

    if (file.size / 1024 > 2048) {
      message.error("يجب عليك رفع ملف بحجم أقل من 2 ميجابايت");
      return;
    }
    if (formData?.get(name)) {
      formData.set(name, file);
    } else {
      formData.append(name, file);
    }
    setDocumentsState({
      ...documentsState,
      [name]: file?.name,
    });
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const handleRemoveFile = (name: string) => {
    formData.delete(name);
    setDocumentsState({
      ...documentsState,
      [name]: false,
    });
  };
  const intl = useIntl();
  return (
    <div className="space-y-5">
      <ModalHeading
        title={intl.formatMessage({ id: "legal_documents_title" })}
        description={intl.formatMessage({ id: "legal_documents_description" })}
      />
      <div className="space-y-5  py-2">
        <div>
          {documentsState.work_permit ? (
            <div className="flex justify-between items-center gap-3 shadow rounded  ">
              <div>
                <p className="text-color-primary px-3">
                  {" "}
                  {intl.formatMessage({ id: `workLicense_title` })}
                </p>
              </div>
              <div className="bg-[#EEF0FF] flex justify-between items-center gap-3  rounded">
                <div className="flex justify-between items-center gap-5 ">
                  <span>{cloudSVG}</span>
                  <span>{documentsState.work_permit}</span>
                </div>
                <Button
                  type="text"
                  htmlType="button"
                  onClick={() => handleRemoveFile("work_permit")}
                >
                  {trashSVG}
                </Button>
              </div>
            </div>
          ) : (
            <Upload
              accept="application/pdf"
              //   action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
              name="work_permit"
              listType="text"
              maxCount={1}
              onRemove={() => {
                formData.delete("work_permit");
              }}
              customRequest={({ file, onSuccess }) =>
                handleUpload({ file, onSuccess }, "work_permit")
              }
            >
              <Button className=" h-16 w-96 px-4  bg-[#FBFBFF]">
                <div className="flex justify-between center gap-2">
                  <div>
                    <p className="text-color-primary text-start">
                      {" "}
                      {intl.formatMessage({ id: `workLicense_title` })}
                    </p>
                    <p className="text-color-sec-title text-sm text-start">
                      {intl.formatMessage({ id: `workLicense_description` })}
                    </p>
                  </div>
                  <div className="self-center bg-color-primary w-6 h-6 rounded flex justify-center items-center">
                    {noneUploadDocument}
                  </div>
                </div>
              </Button>
            </Upload>
          )}
        </div>
        <div>
          {documentsState.insurance_document ? (
            <div className="flex justify-between items-center gap-3 shadow rounded  ">
              <div>
                <p className="text-color-primary px-3">
                  {" "}
                  {intl.formatMessage({ id: `insurance_title` })}
                </p>
              </div>
              <div className="bg-[#EEF0FF] flex justify-between items-center gap-3 px-2 rounded">
                <div className="flex justify-between items-center gap-5 ">
                  <span>{cloudSVG}</span>
                  <span>{documentsState.insurance_document}</span>
                </div>
                <Button
                  type="text"
                  htmlType="button"
                  onClick={() => handleRemoveFile("insurance_document")}
                >
                  {trashSVG}
                </Button>
              </div>
            </div>
          ) : (
            <Upload
              accept="application/pdf"
              //   action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
              name="insurance_document"
              listType="text"
              maxCount={1}
              onRemove={() => {
                formData.delete("insurance_document");
              }}
              customRequest={({ file, onSuccess }) =>
                handleUpload({ file, onSuccess }, "insurance_document")
              }
            >
              <Button className=" h-16 w-96 px-4  bg-[#FBFBFF]">
                <div className="flex justify-between center gap-2">
                  <div>
                    <p className="text-color-primary text-start">
                      {intl.formatMessage({ id: `insurance_title` })}
                    </p>
                    <p className="text-color-sec-title text-sm text-start">
                      {intl.formatMessage({ id: `insurance_description` })}
                    </p>
                  </div>
                  <div className="self-center bg-color-primary w-6 h-6 rounded flex justify-center items-center">
                    {noneUploadDocument}
                  </div>
                </div>
              </Button>
            </Upload>
          )}
        </div>
        <div>
          {documentsState.compliance_regulation ? (
            <div className="flex justify-between items-center gap-3 shadow rounded  ">
              <div>
                <p className="text-color-primary px-3">
                  {intl.formatMessage({ id: `termsAndConditions_title` })}
                </p>
              </div>
              <div className="bg-[#EEF0FF] flex justify-between items-center gap-3 px-2 rounded">
                <div className="flex justify-between items-center gap-5 ">
                  <span>{cloudSVG}</span>
                  <span>{documentsState.compliance_regulation}</span>
                </div>
                <Button
                  type="text"
                  htmlType="button"
                  onClick={() => handleRemoveFile("compliance_regulation")}
                >
                  {trashSVG}
                </Button>
              </div>
            </div>
          ) : (
            <Upload
              accept="application/pdf"
              //   action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
              name="compliance_regulation"
              listType="text"
              maxCount={1}
              onRemove={() => {
                formData.delete("compliance_regulation");
              }}
              customRequest={({ file, onSuccess }) =>
                handleUpload({ file, onSuccess }, "compliance_regulation")
              }
            >
              <Button className=" h-16 w-96 px-4  bg-[#FBFBFF]">
                <div className="flex justify-between center gap-2">
                  <div>
                    <p className="text-color-primary text-start">
                      {intl.formatMessage({ id: `termsAndConditions_title` })}
                    </p>
                    <p className="text-color-sec-title text-sm text-start">
                      {intl.formatMessage({
                        id: `termsAndConditions_description`,
                      })}
                    </p>
                  </div>
                  <div className="self-center bg-color-primary w-6 h-6 rounded flex justify-center items-center">
                    {noneUploadDocument}
                  </div>
                </div>
              </Button>
            </Upload>
          )}
        </div>
      </div>
    </div>
  );
};

export default DocumentsStep;
